module.exports = __webpack_public_path__ + "617e8bf182c17fb101b061c9b59fc430.fbx";